var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddRowBelow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H4v4h8.101a7.018 7.018 0 00-1.427 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v4c0 .033 0 .066-.002.099A7.017 7.017 0 0020 8.674V6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15a5 5 0 11-10 0 5 5 0 0110 0zm-4 3v-2h2v-2h-2v-2h-2v2h-2v2h2v2h2z"
  })));
}

export default SvgAddRowBelow;